<template>
  <div class="checkbox-group" style="overflow: hidden;">
    <van-checkbox-group v-model="selectValue" :max="maxOptionsProxy">
      <van-checkbox
        v-for="item in options"
        :name="item.order"
        :key="item.order"
        shape="square"
        icon-size="20px"
        style="margin-bottom: 20px;"
      >
        {{ getLabel(item.format, item.text) }}
        <template v-if="item.allowedRemark && selectValue.includes(item.order)">
          <span v-if="readonly" style="padding-left: 20px; color: grey;">{{
            multiExtraProxy[item.order]
          }}</span>
          <van-field
            v-else
            :value="multiExtraProxy[item.order]"
            placeholder="请为您的选择作出说明"
            @input="(text) => handleChangeMultiExtra(item.order, text)"
            class="border-bottom"
            @click.stop=""
            :class="{ 'is-error': obtainOptionError(item.order) }"
          />
          <div v-if="obtainOptionError(item.order)" class="error-text" style="padding-left: 0;">
            {{ obtainOptionError(item.order) }}
          </div>
        </template>
      </van-checkbox>
    </van-checkbox-group>
  </div>
</template>
<script>
import { CheckboxGroup, Checkbox, Field } from "vant";
export default {
  name: "checkbox-group",
  components: {
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [Field.name]: Field,
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    value: String,
    extra: String,
    min: Number,
    max: Number,
    options: {
      type: Array,
      default: () => [],
    },
    labelFormat: {
      type: Function,
      required: true,
    },
    readonly: Boolean,
    error: Object,
  },
  computed: {
    selectValue: {
      get() {
        return this.$props.value
          .split(",")
          .map((it) => Number.parseInt(it))
          .filter((it) => !isNaN(it));
      },
      set(value) {
        if (this.$props.readonly) {
          return;
        }
        this.$emit("change", value.join(","));
      },
    },
    maxOptionsProxy() {
      return this.max || this.options.length;
    },
    multiExtraProxy() {
      const { extra } = this.$props;
      if (!extra) {
        return {};
      }
      try {
        return JSON.parse(extra);
      } catch (e) {
        console.error("无效的extra", extra);
        return {};
      }
    },
  },
  methods: {
    obtainOptionError(order) {
      const { error } = this.$props;
      if (error) {
        return error[order];
      }
      return "";
    },
    getLabel(format, text) {
      return this.$props.labelFormat(format, text);
    },
    handleChangeMultiExtra(order, text) {
      const payload = { ...this.multiExtraProxy, [order]: text };
      const extra = JSON.stringify(payload);
      this.emitChangeExtra(extra);
    },
    emitChangeExtra(value) {
      this.$emit("update:extra", value);
      this.$emit("change-extra", value);
    },
  },
};
</script>
<style lang="scss">
.checkbox-group {
  .van-checkbox {
    align-items: flex-start;
  }
  .van-checkbox__icon {
    margin-top: 0.1em;
  }
  .van-checkbox__label {
    flex: 1 1 0;
  }
}
</style>
